<template>
<div class="xiannong-support-page">
    <!-- 田园风格Banner -->
    <div class="farm-support-banner">
        <div class="banner-content">
            <h1>田园生活帮助中心</h1>
            <p>种田小贴士 · 生活答疑站</p>
        </div>
        <div class="nature-helpers">
            <div class="helper-bee" v-for="i in 3" :key="'bee'+i" :style="getBeeStyle(i)">🐝</div>
            <div class="helper-butterfly" v-for="i in 2" :key="'butterfly'+i" :style="getButterflyStyle(i)">🦋</div>
        </div>
    </div>

    <!-- 帮助内容 -->
    <div class="section help-content">
        <div class="container">
            <!-- 联系我 -->
            <div class="help-card contact-section">
                <div class="help-section">
                    <h2 class="section-title">📞 联系我</h2>
                    <div class="contact-methods">
                        <div class="contact-item" v-for="(method, index) in contactMethods" :key="index">
                            <div class="contact-icon" :style="{backgroundColor: method.color}">
                                <div class="icon-symbol">{{ method.symbol }}</div>
                            </div>
                            <div class="contact-info">
                                <h3>{{ method.title }}</h3>
                                <p v-if="method.type === 'email'">
                                    <a :href="`mailto:${method.detail}`">{{ method.detail }}</a>
                                </p>
                                <p v-else-if="method.type === 'phone'">
                                    <a :href="`tel:${method.detail}`">{{ method.detail }}</a>
                                </p>
                                <p v-else>{{ method.detail }}</p>
                                <p class="contact-time" v-if="method.time">{{ method.time }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 常见种植问题 -->
            <div class="help-card faq-section">
                <div class="help-section">
                    <h2 class="section-title">🌱 常见种植问题</h2>
                    <div class="faq-list">
                        <div class="faq-item" v-for="(faq, index) in faqs" :key="index"
                             @click="toggleFaq(index)">
                            <div class="faq-question" :class="{active: activeFaqs.includes(index)}">
                                <span class="faq-number">Q{{ index + 1 }}</span>
                                <span class="faq-text">{{ faq.question }}</span>
                                <span class="faq-icon">{{ activeFaqs.includes(index) ? '👇' : '👉' }}</span>
                            </div>
                            <div class="faq-answer" v-show="activeFaqs.includes(index)">
                                <div class="answer-content">
                                    <div class="answer-text">
                                        <p v-for="(answer, i) in faq.answer" :key="i">{{ answer }}</p>
                                    </div>
                                    <div class="answer-tips" v-if="faq.tips">
                                        <div class="tips-title">💡 小贴士</div>
                                        <ul>
                                            <li v-for="(tip, tipIndex) in faq.tips" :key="tipIndex">{{ tip }}</li>
                                        </ul>
                                    </div>
                                    <div class="answer-image" v-if="faq.plantIcon">
                                        <div class="plant-icon">{{ faq.plantIcon }}</div>
                                        <span class="plant-name">{{ faq.plantName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 种植指南 -->
            <div class="help-card guide-section">
                <div class="help-section">
                    <h2 class="section-title">📚 种植指南</h2>
                    <div class="guide-list">
                        <div class="guide-item" v-for="(guide, index) in guides" :key="index" 
                             @click="openGuide(guide)">
                            <div class="guide-icon" :style="{backgroundColor: guide.color}">
                                <div class="guide-symbol">{{ guide.icon }}</div>
                            </div>
                            <div class="guide-content">
                                <h3>{{ guide.title }}</h3>
                                <p>{{ guide.description }}</p>
                                <div class="guide-meta">
                                    <span class="guide-season">{{ guide.season }}</span>
                                    <span class="guide-difficulty">
                                        难度：<span class="level" :class="guide.difficulty">{{ guide.difficulty }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 工具推荐 -->
            <div class="help-card tools-section">
                <div class="help-section">
                    <h2 class="section-title">🔧 田园工具推荐</h2>
                    <div class="tools-grid">
                        <div class="tool-item" v-for="(tool, index) in tools" :key="index">
                            <div class="tool-icon">{{ tool.icon }}</div>
                            <div class="tool-info">
                                <h4>{{ tool.name }}</h4>
                                <p>{{ tool.description }}</p>
                                <div class="tool-meta">
                                    <span class="tool-price">{{ tool.price }}</span>
                                    <span class="tool-rating">评分：{{ tool.rating }}</span>
                                </div>
                            </div>
                            <div class="tool-tag">{{ tool.category }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 天气指导 -->
            <div class="help-card weather-section">
                <div class="help-section">
                    <h2 class="section-title">☀️ 天气与农事</h2>
                    <div class="weather-guide">
                        <div class="weather-item" v-for="(weather, index) in weatherGuides" :key="index">
                            <div class="weather-icon">{{ weather.icon }}</div>
                            <div class="weather-content">
                                <h4>{{ weather.condition }}</h4>
                                <p>{{ weather.advice }}</p>
                                <div class="weather-actions">
                                    <span v-for="action in weather.actions" :key="action">{{ action }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'XiannongSupportPage',
    data() {
        return {
            activeFaqs: [0],
            contactMethods: [
                {
                    symbol: '📧',
                    title: '联系邮箱',
                    detail: 'xiannong@life.com',
                    type: 'email',
                    color: '#C8E6C9',
                    time: '通常24小时内回复'
                },
                {
                    symbol: '🌾',
                    title: '微信交流',
                    detail: '扫描二维码添加好友',
                    type: 'online',
                    color: '#FFF9C4',
                    time: '可加入田园生活群'
                },
                {
                    symbol: '📱',
                    title: '电话联系',
                    detail: '181-7134-8330',
                    type: 'phone',
                    color: '#B3E5FC',
                    time: '工作日 9:00-17:00'
                },
                {
                    symbol: '📝',
                    title: '留言板',
                    detail: '在网站留言板留言',
                    type: 'message',
                    color: '#FFCDD2',
                    time: '查看过往交流记录'
                }
            ],
            faqs: [
                {
                    question: '西红柿叶子发黄是什么原因？',
                    answer: [
                        '西红柿叶子发黄可能有以下几个原因：',
                        '1. 浇水过多或过少：保持土壤湿润但不积水',
                        '2. 缺乏养分：定期施用有机肥',
                        '3. 光照不足：确保每天6小时以上的日照',
                        '4. 病虫害：检查叶片背面是否有害虫'
                    ],
                    tips: [
                        '早晚浇水，避免中午浇水',
                        '使用发酵的菜籽饼肥效果很好',
                        '及时摘除底部老叶，增加通风'
                    ],
                    plantIcon: '🍅',
                    plantName: '西红柿'
                },
                {
                    question: '黄瓜只开花不结果怎么办？',
                    answer: [
                        '黄瓜开花不结果通常是因为授粉问题：',
                        '1. 人工授粉：用棉签轻轻在雄花和雌花间传递花粉',
                        '2. 吸引蜜蜂：在菜园种植薰衣草、向日葵吸引蜜蜂',
                        '3. 合理施肥：减少氮肥，增加磷钾肥',
                        '4. 适当修剪：摘除过多的侧蔓，保留主蔓结果'
                    ],
                    tips: [
                        '早晨8-10点是最佳授粉时间',
                        '轻摇植株帮助花粉散落',
                        '避免在雨天进行人工授粉'
                    ],
                    plantIcon: '🥒',
                    plantName: '黄瓜'
                },
                {
                    question: '怎样防治菜园的蚜虫？',
                    answer: [
                        '防治蚜虫可以尝试以下自然方法：',
                        '1. 辣椒水：辣椒煮水冷却后喷洒',
                        '2. 肥皂水：稀释的肥皂水喷洒叶片',
                        '3. 吸引天敌：种植香菜、茴香吸引瓢虫',
                        '4. 手动清除：用软布轻轻擦拭叶片',
                        '5. 隔离病株：及时移走严重感染的植株'
                    ],
                    tips: [
                        '大蒜和洋葱的刺激性气味能驱虫',
                        '保持菜园清洁，清除杂草',
                        '早晨喷洒效果最好'
                    ]
                },
                {
                    question: '什么时候适合播种四季豆？',
                    answer: [
                        '四季豆的播种时间因地区而异：',
                        '• 北方地区：4月下旬至5月上旬',
                        '• 南方地区：3月中旬至4月上旬',
                        '• 秋季播种：8月下旬至9月上旬',
                        '最佳播种温度：15-25℃',
                        '出苗时间：一般5-7天'
                    ],
                    tips: [
                        '播种前用温水浸泡种子12小时',
                        '保持土壤湿润但不要过湿',
                        '出苗后及时搭建支架'
                    ]
                },
                {
                    question: '怎样制作堆肥？',
                    answer: [
                        '制作堆肥的简单方法：',
                        '1. 收集材料：菜叶、果皮、干草、咖啡渣等',
                        '2. 分层堆放：一层厨余，一层干料，一层土壤',
                        '3. 保持湿润：每周浇水保持微湿',
                        '4. 定期翻堆：每两周翻动一次增加氧气',
                        '5. 等待发酵：3-6个月后即可使用'
                    ],
                    tips: [
                        '不要放入肉类和油脂',
                        '保持通风但不要暴晒',
                        '加入蚯蚓加速分解'
                    ]
                }
            ],
            guides: [
                {
                    icon: '🍅',
                    title: '西红柿种植全攻略',
                    description: '从育苗到收获的完整种植过程，包括病虫害防治',
                    season: '春-夏',
                    difficulty: '中等',
                    color: '#FFCDD2',
                    link: '/guides/tomato'
                },
                {
                    icon: '🥬',
                    title: '叶菜类快速种植',
                    description: '生菜、菠菜等叶菜的生长周期和种植要点',
                    season: '全年',
                    difficulty: '简单',
                    color: '#C8E6C9',
                    link: '/guides/leafy'
                },
                {
                    icon: '🥕',
                    title: '根茎类蔬菜种植',
                    description: '胡萝卜、萝卜等根茎类蔬菜的深翻土和养护',
                    season: '春秋',
                    difficulty: '中等',
                    color: '#FFCC80',
                    link: '/guides/root'
                },
                {
                    icon: '🫑',
                    title: '茄果类蔬菜指南',
                    description: '茄子、辣椒等茄果类植物的种植技巧',
                    season: '春-夏',
                    difficulty: '较难',
                    color: '#FFF9C4',
                    link: '/guides/solanum'
                }
            ],
            tools: [
                {
                    icon: '🪴',
                    name: '园艺小铲子',
                    description: '不锈钢材质，适合盆栽和菜园小面积翻土',
                    price: '¥28',
                    rating: '4.8',
                    category: '基本工具'
                },
                {
                    icon: '💧',
                    name: '园艺洒水壶',
                    description: '长嘴设计，水流轻柔不伤幼苗',
                    price: '¥35',
                    rating: '4.6',
                    category: '浇水工具'
                },
                {
                    icon: '✂️',
                    name: '修枝剪刀',
                    description: '锋利耐用，适合修剪枝叶和收获蔬菜',
                    price: '¥45',
                    rating: '4.9',
                    category: '修剪工具'
                },
                {
                    icon: '🧤',
                    name: '园艺手套',
                    description: '防刺防滑，透气舒适，保护双手',
                    price: '¥22',
                    rating: '4.5',
                    category: '防护用品'
                },
                {
                    icon: '📏',
                    name: '土壤检测仪',
                    description: '检测土壤湿度、酸碱度和光照强度',
                    price: '¥88',
                    rating: '4.7',
                    category: '检测工具'
                },
                {
                    icon: '🏷️',
                    name: '植物标签',
                    description: '防水防晒，记录种植时间和品种',
                    price: '¥15',
                    rating: '4.4',
                    category: '辅助工具'
                }
            ],
            weatherGuides: [
                {
                    icon: '☀️',
                    condition: '晴天',
                    advice: '适合播种、移栽、施肥和除草',
                    actions: ['浇水', '施肥', '除草']
                },
                {
                    icon: '🌧️',
                    condition: '雨天',
                    advice: '避免户外农事，适合整理工具和阅读种植资料',
                    actions: ['室内整理', '学习', '计划']
                },
                {
                    icon: '⛅',
                    condition: '多云',
                    advice: '适合修剪、绑枝和检查病虫害',
                    actions: ['修剪', '检查', '记录']
                },
                {
                    icon: '🌬️',
                    condition: '大风',
                    advice: '固定支架，保护幼苗，推迟施肥浇水',
                    actions: ['加固', '保护', '延迟施肥']
                },
                {
                    icon: '❄️',
                    condition: '降温',
                    advice: '覆盖保温，减少浇水，保护不耐寒蔬菜',
                    actions: ['覆盖', '保温', '保护']
                }
            ]
        }
    },
    methods: {
        getBeeStyle() {
            const left = Math.random() * 90
            const top = 20 + Math.random() * 60
            const delay = Math.random() * 3
            
            return {
                left: `${left}%`,
                top: `${top}%`,
                animationDelay: `${delay}s`
            }
        },
        getButterflyStyle() {
            const left = Math.random() * 90
            const top = 30 + Math.random() * 40
            const delay = 2 + Math.random() * 3
            
            return {
                left: `${left}%`,
                top: `${top}%`,
                animationDelay: `${delay}s`
            }
        },
        toggleFaq(index) {
            const idx = this.activeFaqs.indexOf(index)
            if (idx > -1) {
                this.activeFaqs.splice(idx, 1)
            } else {
                this.activeFaqs.push(index)
            }
        },
        openGuide(guide) {
            this.$message.success(`查看${guide.title}指南`)
            // 实际项目中这里是路由跳转
        }
    }
}
</script>

<style lang="scss" scoped>
.xiannong-support-page {
    font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
    color: #5a3921;
    background: linear-gradient(to bottom, #f9f7f0 0%, #e8f5e8 100%);
    min-height: 100vh;
}

.farm-support-banner {
    height: 400px;
    background: linear-gradient(135deg, #a8e6cf 0%, #dcedc1 50%, #ffd3b6 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    overflow: hidden;

    .banner-content {
        position: relative;
        z-index: 3;
        
        h1 {
            font-size: 48px;
            margin: 0 0 15px;
            font-weight: 600;
            color: #2e7d32;
            text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.8);
            font-family: 'KaiTi', 'STKaiti', serif;
        }

        p {
            font-size: 20px;
            margin: 0;
            color: #558b2f;
            opacity: 0.9;
        }
    }

    .nature-helpers {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        pointer-events: none;

        .helper-bee {
            position: absolute;
            font-size: 24px;
            animation: beeFly 12s infinite linear;
        }

        .helper-butterfly {
            position: absolute;
            font-size: 28px;
            animation: butterflyFly 15s infinite ease-in-out;
        }
    }
}

@keyframes beeFly {
    0% {
        transform: translateX(0) translateY(0) rotate(0deg);
    }
    25% {
        transform: translateX(100px) translateY(-20px) rotate(10deg);
    }
    50% {
        transform: translateX(200px) translateY(0) rotate(0deg);
    }
    75% {
        transform: translateX(100px) translateY(20px) rotate(-10deg);
    }
    100% {
        transform: translateX(0) translateY(0) rotate(0deg);
    }
}

@keyframes butterflyFly {
    0%, 100% {
        transform: translateX(0) translateY(0);
    }
    25% {
        transform: translateX(80px) translateY(-30px);
    }
    50% {
        transform: translateX(150px) translateY(0);
    }
    75% {
        transform: translateX(80px) translateY(30px);
    }
}

.help-content {
    padding: 60px 0;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
}

.help-card {
    background: white;
    border-radius: 12px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 5px 20px rgba(139, 195, 74, 0.1);
    transition: all 0.3s ease;
    border: 2px solid transparent;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(139, 195, 74, 0.15);
        border-color: #c8e6c9;
    }

    &.contact-section {
        border-left: 6px solid #C8E6C9;
    }

    &.faq-section {
        border-left: 6px solid #FFCDD2;
    }

    &.guide-section {
        border-left: 6px solid #B3E5FC;
    }

    &.tools-section {
        border-left: 6px solid #FFF9C4;
    }

    &.weather-section {
        border-left: 6px solid #FFCCBC;
    }
}

.help-section {
    .section-title {
        color: #5a3921;
        font-size: 24px;
        margin-bottom: 30px;
        padding-bottom: 15px;
        border-bottom: 2px dashed #c8e6c9;
        display: flex;
        align-items: center;
        gap: 10px;
    }
}

.contact-methods {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;

    .contact-item {
        display: flex;
        background: #f9f7f0;
        border-radius: 10px;
        padding: 20px;
        transition: all 0.3s ease;

        &:hover {
            background: #f1f8e9;
            transform: translateX(5px);
        }

        .contact-icon {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            flex-shrink: 0;

            .icon-symbol {
                font-size: 28px;
            }
        }

        .contact-info {
            h3 {
                margin: 0 0 5px;
                font-size: 16px;
                color: #5a3921;
                font-weight: 600;
            }

            p {
                margin: 0;
                color: #8d6e63;
                font-size: 14px;
                line-height: 1.6;

                a {
                    color: #4caf50;
                    text-decoration: none;
                    font-weight: 500;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .contact-time {
                margin-top: 8px;
                color: #a1887f;
                font-size: 12px;
            }
        }
    }
}

.faq-list {
    .faq-item {
        margin-bottom: 10px;
        background: #f9f7f0;
        border-radius: 8px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            background: #f1f8e9;
        }

        .faq-question {
            padding: 20px;
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease;

            &.active {
                background: #e8f5e8;
                color: #2e7d32;
            }

            .faq-number {
                background: #4caf50;
                color: white;
                padding: 4px 10px;
                border-radius: 15px;
                font-size: 14px;
                font-weight: 600;
                margin-right: 15px;
                min-width: 40px;
                text-align: center;
            }

            .faq-text {
                flex: 1;
                font-size: 16px;
                font-weight: 500;
            }

            .faq-icon {
                font-size: 18px;
                transition: transform 0.3s;
            }

            &.active .faq-icon {
                transform: rotate(90deg);
            }
        }

        .faq-answer {
            background: white;
            border-top: 1px solid #e8f5e8;
            
            .answer-content {
                padding: 20px;
                
                .answer-text {
                    p {
                        margin: 0 0 10px;
                        color: #8d6e63;
                        line-height: 1.8;
                        font-size: 14px;
                    }
                }

                .answer-tips {
                    background: #fff9c4;
                    border-radius: 8px;
                    padding: 15px;
                    margin: 15px 0;

                    .tips-title {
                        color: #5a3921;
                        font-weight: 600;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }

                    ul {
                        margin: 0;
                        padding-left: 20px;

                        li {
                            color: #8d6e63;
                            margin-bottom: 5px;
                            font-size: 14px;
                        }
                    }
                }

                .answer-image {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-top: 15px;
                    padding: 15px;
                    background: #f1f8e9;
                    border-radius: 8px;

                    .plant-icon {
                        font-size: 36px;
                    }

                    .plant-name {
                        font-size: 16px;
                        color: #5a3921;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}

.guide-list {
    .guide-item {
        display: flex;
        padding: 20px;
        border-radius: 10px;
        margin-bottom: 15px;
        background: #f9f7f0;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background: #e8f5e8;
            transform: translateX(8px);
        }

        .guide-icon {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            flex-shrink: 0;

            .guide-symbol {
                font-size: 32px;
            }
        }

        .guide-content {
            flex: 1;

            h3 {
                margin: 0 0 8px;
                font-size: 18px;
                color: #5a3921;
                font-weight: 600;
            }

            p {
                margin: 0 0 10px;
                color: #8d6e63;
                font-size: 14px;
                line-height: 1.6;
            }

            .guide-meta {
                display: flex;
                gap: 20px;
                font-size: 13px;
                color: #a1887f;

                .guide-season {
                    background: #e8f5e8;
                    padding: 4px 12px;
                    border-radius: 15px;
                    color: #4caf50;
                }

                .level {
                    font-weight: 600;
                    
                    &.简单 {
                        color: #4caf50;
                    }
                    
                    &.中等 {
                        color: #ff9800;
                    }
                    
                    &.较难 {
                        color: #f44336;
                    }
                }
            }
        }
    }
}

.tools-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;

    .tool-item {
        background: #f9f7f0;
        border-radius: 10px;
        padding: 20px;
        transition: all 0.3s ease;
        position: relative;
        border: 2px solid transparent;

        &:hover {
            background: #f1f8e9;
            border-color: #c8e6c9;
            transform: translateY(-5px);
        }

        .tool-icon {
            font-size: 36px;
            margin-bottom: 15px;
            text-align: center;
        }

        .tool-info {
            h4 {
                margin: 0 0 8px;
                font-size: 16px;
                color: #5a3921;
                font-weight: 600;
            }

            p {
                margin: 0 0 10px;
                color: #8d6e63;
                font-size: 14px;
                line-height: 1.6;
                min-height: 40px;
            }

            .tool-meta {
                display: flex;
                justify-content: space-between;
                font-size: 14px;

                .tool-price {
                    color: #f44336;
                    font-weight: 600;
                }

                .tool-rating {
                    color: #ff9800;
                    font-weight: 500;
                }
            }
        }

        .tool-tag {
            position: absolute;
            top: 10px;
            right: 10px;
            background: #4caf50;
            color: white;
            padding: 4px 10px;
            border-radius: 15px;
            font-size: 12px;
        }
    }
}

.weather-guide {
    .weather-item {
        display: flex;
        align-items: center;
        padding: 15px;
        border-bottom: 1px dashed #c8e6c9;
        transition: all 0.3s ease;

        &:hover {
            background: #f1f8e9;
            border-radius: 8px;
        }

        &:last-child {
            border-bottom: none;
        }

        .weather-icon {
            font-size: 36px;
            margin-right: 20px;
            flex-shrink: 0;
            width: 60px;
            text-align: center;
        }

        .weather-content {
            flex: 1;

            h4 {
                margin: 0 0 5px;
                font-size: 16px;
                color: #5a3921;
                font-weight: 600;
            }

            p {
                margin: 0 0 10px;
                color: #8d6e63;
                font-size: 14px;
                line-height: 1.6;
            }

            .weather-actions {
                display: flex;
                gap: 10px;
                flex-wrap: wrap;

                span {
                    background: #e8f5e8;
                    padding: 4px 12px;
                    border-radius: 15px;
                    font-size: 12px;
                    color: #4caf50;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .farm-support-banner {
        height: 300px;
        
        h1 {
            font-size: 36px;
        }

        p {
            font-size: 18px;
        }
    }

    .help-card {
        padding: 20px;
    }

    .contact-methods {
        grid-template-columns: 1fr;
    }

    .tools-grid {
        grid-template-columns: 1fr;
    }

    .guide-item {
        flex-direction: column;
        text-align: center;

        .guide-icon {
            margin-right: 0;
            margin-bottom: 15px;
        }
    }

    .weather-item {
        flex-direction: column;
        text-align: center;

        .weather-icon {
            margin-right: 0;
            margin-bottom: 15px;
        }
    }
}

@media (max-width: 480px) {
    .farm-support-banner {
        height: 250px;
        
        h1 {
            font-size: 28px;
        }

        p {
            font-size: 16px;
        }
    }

    .section-title {
        font-size: 20px;
    }
}
</style>